import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, AfterViewChecked, AfterContentInit, EventEmitter, Output, HostBinding } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dmi-landing',
  templateUrl: './dmi-landing.component.html',
  styleUrls: ['./dmi-landing.component.scss']
})
export class DmiLandingComponent implements AfterContentInit {

  @HostBinding('class.dmi-landing') dmiLandingClass = true;

  @ViewChild('quad',{ static: true }) quad: ElementRef<HTMLDivElement>;
  @ViewChild('logoContainer',{static:true}) logoContainer: ElementRef<HTMLDivElement>;
  constructor(private router:Router) { }
  @Output()
  public changes = new EventEmitter<'map'|'data'|'org'|'comm'>();
  ngAfterContentInit(): void {
    setTimeout(() => {
      this.quad.nativeElement.classList.toggle('start', false);
      setTimeout(()=>{
        this.logoContainer.nativeElement.classList.toggle('logo-start',false);
      },1500)
    }, 1500);
  }
  CardClick(card:'map'|'data'|'org'|'comm') {
    console.log(card+' clicked');
    this.changes.emit(card);
    if(card === 'map') {
      window.location.href='/dmi/maps';
    }
  }

}
